import React, { Component } from 'react';
import _ from 'underscore';
import { FormControl, FormGroup, Button, ControlLabel } from 'react-bootstrap';
import { Avatar, Left, Right, Tag, Footbar } from '../ui';
import { fetch, urls, genNickName, userSearchMatchs, substrByBytes } from '../utils';

class AddOrEdit extends Component {
    state = {};

    constructor(props) {
        super(props);

        const { session } = props;

        if (session.session_type === 'group') {
            this.state.groupName = session.name;
        }
    }

    async onQuit() {
        const { session, onQuit } = this.props;

        if (!window.confirm("退出该群组不可恢复，您确定要退出吗？")) return;

        let res = await fetch(urls.api.session.quit, {
            method: "post",
            data: _.pick(session, "id")
        });

        if (res.ok) {
            onQuit && onQuit(session);
        } else {
            window.alert(res.message);
        }
    }

    async onSave() {
        const { session, onSave } = this.props;

        let is_group = session.session_type === "group";
        let group = is_group ? _.pick(session, 'id') : {};
        let selectedUsers = this.refs.userTag.getSelectedData();
        let allUsers = (session.users || []).concat(selectedUsers);
        let add_users = is_group ? selectedUsers : allUsers;

        group.name = this.state.groupName;
        onSave && onSave({ srcSession: session, group, add_users });
    }

    render() {
        const { session, userData, onCancel } = this.props;
        let is_group = session.session_type === "group";
        let tagData = _.filter(userData, (item) => {
            return !_.find(session.users, { jid: item.jid });
        });

        let placeholder = session.name || substrByBytes(genNickName(session.users), 22);

        return (
            <div className="group-add-or-edit">
              {
                is_group ? (
                  <FormGroup>
                    <ControlLabel>讨论组名称</ControlLabel>
                    <FormControl value={this.state.groupName} 
                                 placeholder={placeholder} 
                                 onChange={ev=>{this.setState({ groupName: ev.target.value.trim() })}} />
                  </FormGroup> 
                ) : null
              }
              <FormGroup>
                <ControlLabel>成员({session.users.length})</ControlLabel>
                <ul className="flow-list">
                  {
                    session.users.map(item=>{
                      return <Avatar type="normal" src={item.avatar} text={item.nick_name} title={item.nick_name} className={item.status}/>
                    })
                  }
                </ul>
              </FormGroup>
              <FormGroup>
                <ControlLabel>新增</ControlLabel>
                <Tag ref="userTag" data={tagData} textKey="nick_name" matchKeys={userSearchMatchs} placeholder="成员" />
              </FormGroup>
              <Footbar className='clearfix'>
                <Left>
                  <Button onClick={this.onSave.bind(this)} bsStyle='primary' className="mgl-xs">确定</Button>
                  <Button onClick={onCancel} className="mgl-xs">取消</Button>
                </Left>
                {
                  is_group ? (
                    <Right>
                      <a onClick={this.onQuit.bind(this)}> 
                        <i className="icon icon-quit"></i> 
                        退出讨论组
                      </a>
                    </Right> 
                  ) : null
                }
              </Footbar>
            </div>
        );
    }
}

export default AddOrEdit;


// WEBPACK FOOTER //
// ./src/group/addOrEdit.js